import appConfig from "../config/app.config";
import useRestApiCall from "../http.interceptor";
import useGetIpAddress from "./useGetIpAddress";

const useSendEmail = () => {
  const { apiCall } = useRestApiCall();
  const { getIpAddress } = useGetIpAddress();

  const sendEmailPayload = (data) => {
    let apiPayload = {
      method: "POST",
      data,
      url: "api/auth/sendEmail",
      baseURL: appConfig.apiMarketplaceBaseUrl,
    };
    return apiPayload;
  };

  const sendEmail = async ({ subject, body, emailAddress }) => {
    const data = {
      emailBody: body,
      emailSubject: subject,
    };
    try {
      const payload = sendEmailPayload(data);
      const response = await apiCall(payload);
      if (response?.data) {
        return response.data;
      }
     
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  };

  return { sendEmail };
};

export default useSendEmail;
